import React, { useState, useEffect } from 'react';
import {
  UserDetailHeadingCover,
  ExternalServiceStyles,
  ServiceCard,
  LoaderContainer,
} from './styles';
import { Button, Icon } from 'antd';
import ExternalServiceConfigForm from '../../components/Modals/ExternalServiceConfigForm';
import { getConfiguredServices } from '../../utils/services/externalServicesAPI';
import Loader from '../../components/Loader';
import { withTranslation } from 'react-i18next';
import { EXTERNAL_SERVICES } from './TranslationValues';
const NAMESPACE = ['EXTERNAL_SERVICES'];

const ExternalServices = props => {
  const { t } = props;
  const [data, setData] = useState([
    {
      id: 1,
      service: t(EXTERNAL_SERVICES.PRINT_LABEL.key, EXTERNAL_SERVICES.PRINT_LABEL.value),
      icon: 'file-pdf',
      configured: false,
      configType: 'print_config',
    },
    {
      id: 2,
      service: t(EXTERNAL_SERVICES.EMAIL_LABEL.key, EXTERNAL_SERVICES.EMAIL_LABEL.value),
      icon: 'mail',
      configured: false,
      configType: 'email_config',
    },
    {
      id: 3,
      service: t(EXTERNAL_SERVICES.SMS_LABEL.key, EXTERNAL_SERVICES.SMS_LABEL.value),
      icon: 'message',
      configured: false,
      configType: 'sms_config',
    },
  ]);

  const [selectedService, setSelectedService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrintConfig = async () => {
      try {
        const response = await getConfiguredServices();
        if (response && response?.statusCode === 5102) {
          const configuredServices = data.map(channel => {
            const configuration = response.data.find(
              config => config.configType === channel.configType,
            );
            return configuration ? { ...channel, ...configuration, configured: true } : channel;
          });
          setData(configuredServices);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchPrintConfig();
  }, []);

  return (
    <>
      <UserDetailHeadingCover separator>
        <div>
          <h5>{t(EXTERNAL_SERVICES.EXTERNAL_SERVICES_HEADING.key, EXTERNAL_SERVICES.EXTERNAL_SERVICES_HEADING.value)}</h5>
          <p>
            {t(EXTERNAL_SERVICES.EXTERNAL_SERVICES_DESC.key, EXTERNAL_SERVICES.EXTERNAL_SERVICES_DESC.value)}
          </p>
        </div>
      </UserDetailHeadingCover>

      {loading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <ExternalServiceStyles>
          {data.map(service => {
            return (
              <ServiceCard
                key={service.id}
                active={selectedService === service.id}
                configured={service.configured}
              >
                {service.configured && (
                  <div className="configured">
                    <Icon type="check" /> {t(EXTERNAL_SERVICES.CONFIGURED_LABEL.key, EXTERNAL_SERVICES.CONFIGURED_LABEL.value)}
                  </div>
                )}
                <div className="service-card">
                  <div className="service-card-header">
                    <div className="icon-wrapper">
                      <Icon type={service.icon} />
                    </div>
                    <h1>{service.service}</h1>
                  </div>

                  {selectedService !== service.id && (
                    <div className="button-wrapper">
                      <Button onClick={() => setSelectedService(service.id)}>
                        {service.configured ? (
                          <>
                            <Icon type="form" /> {t(EXTERNAL_SERVICES.UPDATE_BUTTON.key, EXTERNAL_SERVICES.UPDATE_BUTTON.value)}
                          </>
                        ) : (
                          <>
                            <Icon type="setting" /> {t(EXTERNAL_SERVICES.CONFIGURE_BUTTON.key, EXTERNAL_SERVICES.CONFIGURE_BUTTON.value)}
                          </>
                        )}
                      </Button>
                    </div>
                  )}
                </div>
                {selectedService === service.id && (
                  <ExternalServiceConfigForm
                    data={service}
                    isEditing={service.configured}
                    setData={setData}
                  />
                )}
              </ServiceCard>
            );
          })}
        </ExternalServiceStyles>
      )}
    </>
  );
};

export default withTranslation(NAMESPACE)(ExternalServices);
